module.exports = __webpack_public_path__ + "img/example-png.1ab67b7c.svg";